type GoogleAttributionNativePlugin = {
  getAdvertisingId?: () => Promise<{ gaid?: string; limitAdTracking?: boolean }>;
  getInstallReferrer?: () => Promise<{ installReferrer?: string }>;
};

function getPlugin(): GoogleAttributionNativePlugin | null
{
  return ( window as unknown as { Capacitor?: { Plugins?: { GoogleAttribution?: GoogleAttributionNativePlugin } } } )
    .Capacitor?.Plugins?.GoogleAttribution ?? null;
}

function queryValue( source: string, name: string ): string | undefined
{
  try
  {
    const value = new URLSearchParams( source ).get( name )?.trim();
    return value || undefined;
  }
  catch
  {
    return undefined;
  }
}

export type GoogleAttributionIdentifiers = {
  gaid?: string;
  gclid?: string;
  market_referrer_gclid?: string;
  gbraid?: string;
};

export const GoogleAttributionPlugin = {
  async getIdentifiers(): Promise<GoogleAttributionIdentifiers>
  {
    const plugin = getPlugin();
    if ( !plugin ) return {};

    const [ advertising, referrer ] = await Promise.all( [
      plugin.getAdvertisingId?.().catch( () => undefined ),
      plugin.getInstallReferrer?.().catch( () => undefined ),
    ] );
    const install_referrer = referrer?.installReferrer ?? '';

    return {
      ...( advertising?.limitAdTracking === false && advertising.gaid ? { gaid: advertising.gaid } : {} ),
      ...( queryValue( install_referrer, 'gclid' ) ? { market_referrer_gclid: queryValue( install_referrer, 'gclid' ) } : {} ),
      ...( queryValue( install_referrer, 'gbraid' ) ? { gbraid: queryValue( install_referrer, 'gbraid' ) } : {} ),
    };
  },
};
